module.exports = __webpack_public_path__ + "img/Kinesis-Putih-mini.86bbf8cb.png";